
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tentang-perusahaan",
      function () {
        return require("private-next-pages/tentang-perusahaan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tentang-perusahaan"])
      });
    }
  